import type { EAnalyticMode } from '../../types';

export interface IBuildModeQueryParams {
  mode: EAnalyticMode;
}

const build = (mode: EAnalyticMode) => `MODE ${mode}`;

const parse = (query: string): EAnalyticMode | undefined => {
  const match = query.match(/\bMODE\s+(\S+)/i);
  return match?.[1] as EAnalyticMode | undefined;
};

export { build as buildModeQuery, parse as parseModeQuery };
